// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/positive-relationships.svg';

export const PositiveRelationships = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
